import { render, staticRenderFns } from "./AssignedTodoDetailModal.vue?vue&type=template&id=2d062c7e&"
import script from "./AssignedTodoDetailModal.vue?vue&type=script&lang=js&"
export * from "./AssignedTodoDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports